import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { IRadarListing, INotifier } from '../../..//models/radar.listing';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('ListingsListDelegate')
export class ListingsListDelegate extends DataDelegate {

    private _totalItems: number = 100;
    get TotalItems(): number {
        return this._totalItems;
    }
    set TotalItems(num: number) {
        this._totalItems = num;
    }

    private _currentPage: number = 100;
    get CurrentPage(): number {
        return this._currentPage;
    }
    set CurrentPage(num: number) {
        this._currentPage = num;
    }

    constructor() {
        super('ShowingsListDelegate');
    }

    public async getListings(page: number) {
        // await T_T.delay(2000);
        // const dataSource = new DummyDataDelegate();
        // this.Data = await dataSource.fetchListingData();
        // return 1;
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        const fetched = await AxiosPromise.get(`${apiHost}/listings/pagination?pageSize=10&pageNo=${page}`);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            this.TotalItems = fetched.data.total;
            this.CurrentPage = page;
            const data: IRadarListing[] = fetched.data.list.map((v: any) => this._listingMapper(v));
            this.Data = data;
            return 1;
        } else {
            return 0;
        }
    }

    public async searchListings(address: string, city: string, mlsNumber: string, agent: string) {
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        let uri = `${apiHost}/listings/pagination?pageSize=100&pageNo=1`;
        if (T_T.simpleDetect(address) && address !== '') {
            uri += `&addr=${address}`;
        }
        if (T_T.simpleDetect(city) && city !== '') {
            uri += `&city=${city}`;
        }
        if (T_T.simpleDetect(mlsNumber) && mlsNumber !== '') {
            uri += `&mls=${mlsNumber}`;
        }
        if (T_T.simpleDetect(agent) && agent !== '') {
            uri += `&agentName=${agent}`;
        }
        const fetched = await AxiosPromise.get(uri);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            const data: IRadarListing[] = fetched.data.list.map((v: any) => this._listingMapper(v));
            this.Data = data;
            return 1;
        } else {
            return 0;
        }
    }

    private _listingMapper(data: any): IRadarListing {
        const listing: IRadarListing = {
            status: T_T.simpleDetect(data.xStatus) ? data.xStatus : '',
            id: T_T.simpleDetect(data.id) ? data.id : '',
            created_date: T_T.simpleDetect(data.xShowingDate) ? data.xShowingDate : '',
            address: T_T.simpleDetect(data.xAddress) ? data.xAddress : '',
            city: T_T.simpleDetect(data.xCity) ? data.xCity : '',
            mls_number: T_T.simpleDetect(data.xMlsnumber) ? data.xMlsnumber : '',
            notifier_one: this.listingNotifierOneMapper(data),
            notifier_two: this.listingNotifierTwoMapper(data),
            instruction: T_T.simpleDetect(data.xInstruction) ? data.xInstruction : '',
            price: T_T.simpleDetect(data.xPrice) ? data.xPrice : '',
            lockbox: T_T.simpleDetect(data.xLockbox) ? data.xLockbox : '',
            listing_agent_one: this.listingAgentOneMapper(data),
            listing_agent_two: this.listingAgentTwoMapper(data),
        };
        return listing;
    }

    public listingAgentOneMapper(data: any) {
        if (T_T.simpleDetect(data)) {
            if (T_T.simpleDetect(data.agentList)) {
                if (data.agentList.length > 0) {
                    if (T_T.simpleDetect(data.agentList[0].name)) {
                        return data.agentList[0].name;
                    }
                }
            }
        }
        return '';
    }

    public listingAgentTwoMapper(data: any) {
        if (T_T.simpleDetect(data)) {
            if (T_T.simpleDetect(data.agentList)) {
                if (data.agentList.length > 1) {
                    if (T_T.simpleDetect(data.agentList[1].name)) {
                        return data.agentList[1].name;
                    }
                }
            }
        }
        return '';
    }

    public listingNotifierOneMapper(data: any) {
        const notifier: INotifier = {
            id: '',
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            showing_cancel: false,
            showing_confirm: false,
            showing_request: false,
            showing_feedback: false
        };
        if (T_T.simpleDetect(data)) {
            if (T_T.simpleDetect(data.notifiers)) {
                if (data.notifiers.length > 0) {
                    const notifierFetched: any = data.notifiers[0];
                    notifier.id = notifierFetched.id;
                    notifier.first_name = notifierFetched.xFirstname;
                    notifier.last_name = notifierFetched.xLastname;
                    notifier.phone = notifierFetched.xPhone;
                    notifier.email = notifierFetched.xEmail;
                    notifier.showing_cancel = notifierFetched.xNoticeCancel;
                    notifier.showing_confirm = notifierFetched.xNoticeConfirm;
                    notifier.showing_feedback = notifierFetched.xNoticeFeedback;
                    notifier.showing_request = notifierFetched.xNoticeRequest;
                    return notifier;
                }
            }
        }
        return notifier;
    }

    public listingNotifierTwoMapper(data: any) {
        const notifier: INotifier = {
            id: '',
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            showing_cancel: false,
            showing_confirm: false,
            showing_request: false,
            showing_feedback: false
        };
        if (T_T.simpleDetect(data)) {
            if (T_T.simpleDetect(data.notifiers)) {
                if (data.notifiers.length > 1) {
                    const notifierFetched: any = data.notifiers[1];
                    notifier.id = notifierFetched.id;
                    notifier.first_name = notifierFetched.xFirstname;
                    notifier.last_name = notifierFetched.xLastname;
                    notifier.phone = notifierFetched.xPhone;
                    notifier.email = notifierFetched.xEmail;
                    notifier.showing_cancel = notifierFetched.xNoticeCancel;
                    notifier.showing_confirm = notifierFetched.xNoticeConfirm;
                    notifier.showing_feedback = notifierFetched.xNoticeFeedback;
                    notifier.showing_request = notifierFetched.xNoticeRequest;
                    return notifier;
                }
            }
        }
        return notifier;
    }
}
